import type { CommandHandler } from '../types';
import { isInboundFinanceEmailHistoryId } from '../../utils/financeEmailHistoryId';

export const replyToFinanceEmailCommandHandler: CommandHandler = async (_command, context) => {
  const historyId = String(context.entityId ?? context.parentId ?? '').trim();
  if (!isInboundFinanceEmailHistoryId(historyId)) {
    return {
      success: false,
      error: 'Reply is only available for inbound finance emails.',
    };
  }

  const direction = String(context.entityData?.Direction ?? context.entityData?.direction ?? '')
    .trim()
    .toLowerCase();
  if (direction && direction !== 'inbound') {
    return {
      success: false,
      error: 'Reply is only available for inbound finance emails.',
    };
  }

  if (!context.openReplyToFinanceEmailDialog) {
    return {
      success: false,
      error: 'Reply dialog is not available.',
    };
  }

  return context.openReplyToFinanceEmailDialog(historyId);
};
